import React, {useEffect, useState} from 'react';
import { TranslationView } from '@levelapp/softfabric-ui';
import {Image, Text, View} from 'react-native';
import {styles} from "./LocalisationViewStyle";
import {getImageAspectRatio} from "../../../../../Common/Utils/image.utils";
import {useWindowSizeContext} from "../../../../../Common/contexts/WindowSizeContext";

interface LocalisationViewProps {
    address: string;
    projectLocalisationText: string;
    localisationImages: any[];
}

export const LocalisationView = ({address, projectLocalisationText, localisationImages}: LocalisationViewProps) => {

    const {width: screenWidth, isMobile} = useWindowSizeContext();

    const imagesUrl = localisationImages.map((image: any) => image.url);

    const [imagesAspectRatio, setImagesAspectRatio] = useState<number[]>([]);

    const maxWidth = isMobile ? screenWidth*0.7 : screenWidth*0.4;

    useEffect(() => {
        if (imagesAspectRatio.length === 0 && imagesUrl.length !== 0) {
            (async () => {
                try {
                    const ratios = await Promise.all(imagesUrl.map((url:string) => getImageAspectRatio(url)));
                    setImagesAspectRatio(ratios as number[]);
                } catch (error) {
                    console.error("Error fetching aspect ratios", error);
                }
            })();
        }
    }, [imagesAspectRatio.length, imagesUrl]);


    function constructGoogleAddress() {
        const google1 = "https://maps.google.com/maps?q=";
        const google2 = "&t=m&z=16&output=embed&iwloc=near";

        // Remplacer les espaces par %20 pour l'URL
        const formattedAddress = encodeURIComponent(address);

        // Construire l'URL finale
        return google1 + formattedAddress + google2;
    }

    if (projectLocalisationText.length === 0 && localisationImages.length === 0 && address.length === 0) {
        return null;
    }

    return (
      <View style={[styles.page]}>
        <TranslationView style={styles.title}>localisationTitle</TranslationView>
          {projectLocalisationText.length > 0 &&
              <Text style={styles.text}>{projectLocalisationText}</Text>
          }
          {localisationImages.length > 0 && (
              <View style={styles.line}>
                  {localisationImages.map((image: any, index: number) => {
                      return (
                          <Image key={index} style={styles.image} source={{ uri: image.url, width: maxWidth, height: maxWidth / imagesAspectRatio[index] }} />
                      )
                  })}
              </View>
          )}
          {address && address.length > 0 && (
            <View style={styles.map}>
                <iframe style={{ border: 'none', borderWidth: 1, borderRadius: 24, borderColor: "white"}} src={constructGoogleAddress()} title={constructGoogleAddress()} height={"100%"}/>
            </View>
          )}
      </View>
    );
}

export default LocalisationView;